import React from 'react';
import { Button } from './Button';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className = ''
}: EmptyStateProps) {
  return <div className={`flex flex-col items-center justify-center p-12 text-center border border-dashed border-border/50 rounded-lg bg-black/20 ${className}`} data-id="element-145">
      <div className="relative mb-6" data-id="element-146">
        {/* Tactical Radar/Scanline Background Effect */}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-147">
          <div className="w-24 h-24 rounded-full border border-primary/20 animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite]" data-id="element-148"></div>
          <div className="absolute w-16 h-16 rounded-full border border-primary/30 animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite]" data-id="element-149"></div>
          <div className="absolute w-32 h-32 rounded-full border border-primary/10" data-id="element-150"></div>
          {/* Crosshair */}
          <div className="absolute w-full h-[1px] bg-primary/20" data-id="element-151"></div>
          <div className="absolute h-full w-[1px] bg-primary/20" data-id="element-152"></div>
        </div>

        {/* Icon Container */}
        <div className="relative z-10 w-16 h-16 bg-black/60 border border-primary/30 rounded-xl flex items-center justify-center shadow-[0_0_15px_rgba(var(--primary),0.15)] backdrop-blur-sm" data-id="element-153">
          <Icon className="w-8 h-8 text-primary opacity-80" data-id="element-154" />
        </div>
      </div>

      <h3 className="text-sm font-mono font-bold uppercase tracking-widest text-foreground mb-2" data-id="element-155">
        {title}
      </h3>
      <p className="text-xs font-mono text-muted-foreground max-w-sm leading-relaxed mb-6" data-id="element-156">
        {description}
      </p>

      {actionLabel && onAction && <Button variant="outline" onClick={onAction} className="border-primary/50 text-primary hover:bg-primary/10 font-mono text-xs tracking-widest uppercase" data-id="element-157">
          {actionLabel}
        </Button>}
    </div>;
}